<template>
    <v-card>
        <v-card-title class="font-weight-bold darkgrey--text">
            {{ $attrs.detail.intrepretation_id ? "Ubah" : "Tambah" }}
            Interpretasi
        </v-card-title>
        <v-card-text class="mt-5">
            <span class="font-weight-bold">
                {{
                    $attrs.scale.question_type === "choice"
                        ? "Kode Dominan"
                        : "Rentang Score"
                }}
            </span>

            <div
                v-if="$attrs.scale.question_type === 'choice'"
                class="mt-2"
                style="width: 40%"
            >
                <div>
                    <v-select
                        v-model="data.most_result"
                        :items="value_answer"
                        outlined
                        placeholder="Kode"
                    ></v-select>
                </div>
            </div>

            <div
                v-else
                class="d-flex mt-2"
                style="align-items: baseline; gap: 10px; width: 80%"
            >
                <div>
                    <v-text-field
                        v-model="data.min_result"
                        outlined
                        placeholder="Score"
                        maxlength="3"
                        @keypress="handleInputNumber($event)"
                    ></v-text-field>
                </div>

                <div>
                    <span class="font-weight-bold">sampai</span>
                </div>

                <div>
                    <v-text-field
                        v-model="data.max_result"
                        outlined
                        placeholder="Score"
                        maxlength="3"
                        @keypress="handleInputNumber($event)"
                    ></v-text-field>
                </div>
            </div>
        </v-card-text>
        <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="darkFade" text @click="$emit('close')"> Tutup </v-btn>
            <v-btn
                color="blew"
                depressed
                text
                :loading="isLoading"
                @click="save()"
            >
                Simpan
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import ambis_test from "../services/ambis_test";

export default {
    name: "dialog-range",
    data: function () {
        return {
            isLoading: false,
            selectedPicture: null,
            data: {
                scale_id: "",
                min_result: "",
                max_result: "",
                most_result: "",
                max_page: "",
            },
            url: null,
            addNew: false,
            keyimg: 0,
            imageFile: null,
        };
    },

    computed: {
        value_answer() {
            const value_answer = this.$attrs.scale.value_answer;
            return value_answer.split(";");
        },
    },

    mounted() {
        if (this.$attrs.detail.intrepretation_id) {
            this.getDetailRange();
        }
    },

    methods: {
        async save() {
            var context = this;
            const intrepretation_id = context.$attrs.detail.intrepretation_id;
            context.data.scale_id = context.$attrs.scale.id;

            if (this.validateForm()) {
                context.isLoading = true;
                if (!intrepretation_id) {
                    ambis_test.addRange(context.data, function (result) {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                        }
                        context.isLoading = false;
                        context.$emit("save");
                    });
                } else {
                    ambis_test.editRange(
                        intrepretation_id,
                        context.data,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                                context.isLoading = false;
                                context.$emit("save");
                            }
                        },
                    );
                }
            }
        },

        getDetailRange() {
            this.data = {
                scale_id: this.$attrs.scale.id,
                min_result: this.$attrs.detail.min_result,
                max_result: this.$attrs.detail.max_result,
                most_result: this.$attrs.detail.most_value,
                max_page: this.$attrs.detail.max_page,
            };
        },

        validateForm() {
            var err = false;
            if (this.$attrs.scale.question_type === "choice") {
                if (!this.data.most_result) {
                    this.$store.commit("showAlert", {
                        message: `Kode dominan harus diisi`,
                        type: "error",
                    });
                    err = true;
                }
            } else {
                if (!this.data.min_result) {
                    this.$store.commit("showAlert", {
                        message: `Minimum score harus diisi`,
                        type: "error",
                    });
                    err = true;
                } else if (!this.data.max_result) {
                    this.$store.commit("showAlert", {
                        message: `Maximum score harus diisi`,
                        type: "error",
                    });
                    err = true;
                }
            }

            return !err;
        },

        handleInputNumber(event) {
            if (!/\d/.test(event.key)) return event.preventDefault();
        },
    },
};
</script>



// WEBPACK FOOTER //
// DialogRange.vue?337ccb15